const DEFAULT_CAMPAIGN_ID = process.env.GATSBY_DEFAULT_CAMPAIGN_ID;

module.exports = {
    brandInfo: {
        phoneNumber: "18885364210",
        contactEmail: "info@pretsautocanada.ca",
        address: "10 Lower Spadina Ave, Toronto ON",
        copyright: `© ${new Date().getFullYear()} Prêts Auto Canada`,
        defaultCampaignId: "247",
    },

    images: {
        icon: "images/favicon.png",
        logo: "images/PretsAutoCanada-Logo.png",
    },

    project: "pretsauto-credit-application",
    name: "Prêts Auto Canada",
    shortName: `Prêts Auto Canada`,
    title: `Demande Prêts Auto Canada`,
    description: `Obtenez les meilleurs taux sur les meilleurs véhicules disponibles!`,
    reportingDomain: "carloanscanada.com",

    siteUrl: "https://www.carloanscanada.com/application",
    homeUrl: "/",
    termsUrl: "/terms_of_use",
    privacyPolicyUrl: "/privacy_policy",
    successUrl: "/success",

    hideSuccessCtas: true,
    layout: {
        component: require.resolve("./src/layout/index.jsx"),
        theme: require.resolve("./themes/custom/single-page-theme.js"),
    },
    requiredPartialFields: [
        "firstName",
        "lastName",
    ],
};
